import * as React from "react";
import { Video } from "@grandvisionhq/content";
import { compose } from "@grandvisionhq/utils";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
const CmsVideo = ({ component }) => {
  const { coverImage } = component.getModels();
  const { videoUrl } = component.getParameters();
  if (!videoUrl) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Video, { videoUrl, coverImage });
};
const CmsVideo$1 = compose(withBreakpointVisibility, withAnchor)(CmsVideo);
export {
  CmsVideo,
  CmsVideo$1 as default
};
//# sourceMappingURL=Video.js.map
